/**
 * Created by neo on 26.02.17.
 */
import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import FlightOffer from '../../Store/FlightOffer';
import { Alert, Row, Col, Button, Input, FormGroup, Label } from 'reactstrap';
import LanguageStore from '../../../lang';
import DisplayToggle from '../../Components/DisplayToggle';
import Settings from '../../Store/Settings';
import Location from '../../Store/Location';
import { withRouter } from 'react-router';

@observer
export class FlightOfferSection extends React.Component<any, void> {
  @observable response: any = { first: true, last: true };
  @observable loading: boolean = true;
  @observable firstLoad: boolean = true;
  @observable flightOffers: Array<FlightOffer> = [];
  @observable pickupLocations: Array<Location> = [];
  @observable page: number = 1;
  @observable selectedLocationId: number = 0;
  @observable selectedFlightOfferId: number = 0;
  @observable flightOffersFromSelectedLocation: Array<FlightOffer> = [];

  componentDidMount() {
    this.load();
  }

  async load() {
    this.loading = true;

    try {
      this.response = await FlightOffer.loadTransfers();
      if (!this.response || !this.response.content) {
        throw new Error('Invalid response or content missing');
      }
      this.flightOffers = this.flightOffers.concat(this.response.content);

      // make unique array of pickup locations
      const pickupLocations = this.flightOffers.map(f => f.location);
      this.pickupLocations = pickupLocations.filter((l, i) => {
        const firstIndex = pickupLocations.findIndex(ll => ll.id === l.id);
        return firstIndex === i;
      }).sort((a, b) => a.name.localeCompare(b.name));

      const selectedLocationId = this.pickupLocations.length ? +this.pickupLocations[0].id : null;
      this.changePickupLocation({
        target: {
          value: selectedLocationId,
        },
      });
    } catch (error) {
      console.error('Failed to load flight offers:', error);
      // Handle the error appropriately
    } finally {
      this.loading = false;
      this.firstLoad = false;
    }
  }


  changePickupLocation = (e) => {
    this.selectedLocationId = +e.target.value;
    // we don't need unique array, as it is already filtered on backend
    this.flightOffersFromSelectedLocation = this.flightOffers
      .filter(f => +f.location.id === +e.target.value)
      .sort((a, b) => a.dropoff_location.name.localeCompare(b.dropoff_location.name));

    this.selectedFlightOfferId = this.flightOffersFromSelectedLocation.length ? this.flightOffersFromSelectedLocation[0].id : null;
  };

  changeFlightOffer = (e) => {
    this.selectedFlightOfferId = +e.target.value;
  };

  handleBook = () => {
    if (this.selectedFlightOfferId) {
      this.props.router.push(`/offer/${this.selectedFlightOfferId}`);
    }
  };

  render() {
    const {
      props: { t },
      loading,
      firstLoad,
      pickupLocations,
      selectedFlightOfferId,
      selectedLocationId,
      flightOffersFromSelectedLocation,
    } = this;

    const { settings } = Settings;

    return (
      <Row className='transfer-flights-container'>
        <Col lg={12}>
          <h1>{t('Transfer flights')}</h1>
          <div className='selects-container'>
            <Row style={{ width: '100%', margin: 0 }}>
              <Col md={5} className='p-0 pr-md-3'>
                <FormGroup>
                  <Label>{t('Pick-up location')}</Label>
                  <Input type='select' value={selectedLocationId} onChange={this.changePickupLocation}>
                    {pickupLocations.map((l, i) => (
                      <option key={i} value={l.id}>{l.name}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={5} className='p-0 pr-md-3'>
                <FormGroup>
                  <Label>{t('Drop-off location')}</Label>
                  <Input type='select' value={selectedFlightOfferId} onChange={this.changeFlightOffer}>
                    {flightOffersFromSelectedLocation.map((f, i) => (
                      <option key={i} value={f.id}>{f.dropoff_location.name}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={2} className='p-0'>
                <FormGroup>
                  <Label>&nbsp;</Label>
                  <Button disabled={!this.selectedFlightOfferId} block color='secondary' onClick={this.handleBook}>
                    {t('Book')}
                  </Button>
                </FormGroup>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    );
  }
}

export default withRouter(translate()(FlightOfferSection));



// WEBPACK FOOTER //
// ./src/App/Dashboard/Transfers/index.js